import { AssignmentIndOutlined, BadgeOutlined, LockClockOutlined, PasswordOutlined, PersonOutlined, PunchClockOutlined, Restore, RocketLaunchOutlined, SettingsOutlined } from '@mui/icons-material'
import { useMediaQuery } from '@mui/material'
import React, { useContext, useState, useEffect } from 'react'
import { BufferService, LoadingContext, M_TabsInpage, NavigateContext, M_StateActions } from '../M_Components'
import { ChangePassword } from './ChangePassword'
import { useTranslation } from 'react-i18next'
import { UserConfig } from 'src/pages/userConfig'
import { RoleConfig } from 'src/pages/roleConfig'
import { useDispatch, useSelector } from 'react-redux'
import Profile from './profile'
import RecentActivity from './recentActivity'
import Logs from './logs'
import './settings.css'
import ConfigSettings from './configSettings'
import LogsPage from './LogsPage'
import CreateChangeLog from './createChangeLog'

export const SettingsPage = () => {
  const dispatch = useDispatch()
  const M_State = useSelector((state) => state.StateKeyValue)
  const ctx = useContext(LoadingContext)
  const ctx2 = useContext(NavigateContext)
  const matches = useMediaQuery('(min-width:900px)')
  const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
  const [menu, setMenu] = useState(1)
  const [user, setUser] = useState(null)
  const UserService = new BufferService('identity/userrole')
  const { t } = useTranslation()

  const sessionKeys = ['menu', 'user']

  function getSessionKeys() {
    return [
      menu, user
    ]
  }

  useEffect(() => {
    getSessionStorageData(id)
    // eslint-disable-next-line
  }, [])

  const getSessionStorageData = (sessionID) => {
    ctx.setIsLoad(true)
    const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
    if (M_StateData) {
      const tempM = M_StateData?.filter(obj => obj?.key === `menu`)[0]?.value
      const tempU = M_StateData?.filter(obj => obj?.key === `user`)[0]?.value
      if (tempM || tempU) {
        setMenu((tempM))
        setUser((tempU))
        ctx.setIsLoad(false)
        return
      }
    }
    get()
  }

  const sessionStorageMachine = (id, key, value) => {
    let tempObj = {}
    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
    } else {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (eval(value)) }
    }
    return tempObj
  }

  // eslint-disable-next-line
  useEffect(() => {
    const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
    if (newId !== id) {
      setId(newId)
      getSessionStorageData(newId)
    }
  })

  useEffect(() => {
    const tempArray = []
    sessionKeys.forEach(key => {
      tempArray.push(sessionStorageMachine(id, key, key))
    })
    dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
    // eslint-disable-next-line
  }, [id, menu, user])

  const get = () => {
    ctx.setIsLoad(true)
    UserService.get().then(res => {
      ctx.setIsLoad(false)
      if (res.name === 'AxiosError') {
        ctx.toastMessages('error', res.response.data.Errors.toString(), '')
        return
      }
      setUser(res)
    })
  }

  const permissions = (roleDetail) => {
    const tempRoleDetails = user?.RoleDetails?.map(vl => vl.Value)
    let tempBol = false
    tempRoleDetails?.forEach(detail => {
      if (detail.match(`${roleDetail}List`)) {
        tempBol = true
      }
    })
    return tempBol
  }

  const allowedTabs = () => {
    const tabArray = []
    tabArray.push({ iconTab: <AssignmentIndOutlined style={{ fontSize: '1.5rem' }} />, labelTab: t('Profile'), id: 1 },)

    tabArray.push({ iconTab: <PasswordOutlined style={{ fontSize: '1.5rem' }} />, labelTab: t('ChangePassword'), id: 2 },)

    if (permissions('user config')) {
      tabArray.push({ iconTab: <PersonOutlined style={{ fontSize: '1.5rem' }} />, labelTab: t('Users'), id: 3 })
    }
    if (permissions('role config')) {
      tabArray.push({ iconTab: <BadgeOutlined style={{ fontSize: '1.5rem' }} />, labelTab: t('Roles'), id: 4 })
    }

    if (permissions('settings')) {
      tabArray.push({ iconTab: <SettingsOutlined style={{ fontSize: '1.5rem' }} />, labelTab: t('Settings'), id: 5 })
    }

    tabArray.push({ iconTab: <LockClockOutlined style={{ fontSize: '1.5rem' }} />, labelTab: t('RecentActivity'), id: 6 },)

    if (permissions('logs')) {
      tabArray.push({ iconTab: <Restore style={{ fontSize: '1.5rem' }} />, labelTab: t('Logs'), id: 7 })
    }

    tabArray.push({ iconTab: <RocketLaunchOutlined style={{ fontSize: '1.5rem' }} />, labelTab: t('PatchNotes'), id: 8 },)

    if (permissions('Create ChangeLog')) {
      tabArray.push({ iconTab: <PunchClockOutlined style={{ fontSize: '1.5rem' }} />, labelTab: t('CreateChangeLog'), id: 9 },)
    }
    return tabArray

  }

  return (
    <div className='divGlobalSettings' data-testid="settings-page">
      <div className='titleSettings' style={{ color: ctx.secondaryColor }} data-testid="settings-title">
        {t("SettingsSpan")}
      </div>
      <div style={matches ? { display: 'flex' } : {}} data-testid="settings-container">
        <div style={matches ? { width: '300px' } : {}} data-testid="settings-tabs">
          <M_TabsInpage
            type={matches ? 'column' : 'tabs'}
            renderTabs={allowedTabs()}
            firstTabOpen={menu}
            onGetTab={(obj, obj2) => {
              if (matches) {
                setMenu(obj.id)
              } else {
                setMenu(obj2.id)
              }
            }}
          />
        </div>
        <div className='settingsPageMainDiv'>
          {menu == '1' && <Profile />}
          {menu == '2' && <ChangePassword Email={user?.User?.Email} />}
          {menu == '3' && <UserConfig roles={user.RoleDetails.map(vl => vl.Value)} onCreateTab={ctx2.newTab} toastMessages={ctx.toastMessages} />}
          {menu == '4' && <RoleConfig roles={user.RoleDetails.map(vl => vl.Value)} onCreateTab={ctx2.newTab} toastMessages={ctx.toastMessages} />}
          {menu == '5' && <ConfigSettings />}
          {menu == '6' && <RecentActivity />}
          {menu == '7' && <Logs />}
          {menu == '8' && <LogsPage />}
          {menu == '9' && <CreateChangeLog roles={user.RoleDetails.map(vl => vl.Value)} onCreateTab={ctx2.newTab} toastMessages={ctx.toastMessages} />}
        </div>
      </div>
    </div>
  )

}
